import AppCard from "@lib/components/AppComponents/AppCard";
import { Row, Typography } from "antd";
import { rgba } from "polished";
import styled from "styled-components";

export const StyledAppCard = styled(AppCard)`
  .ant-card-body {
    padding: 0;
  }
`;

export const StyledMiniInfoWrapper = styled.div<{ color?: string }>`
  flex: 1;
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;
  min-height: 74px;
  width: 100%;
  padding: 16px;

  .info-icon {
    background-color: ${({ color, theme }) =>
      color ? rgba(color, 0.1) : theme.palette.background.default};
    color: ${({ color, theme }) => color || theme.palette.text.primary};
    font-size: 30px;
    min-width: 50px;
    min-height: 50px;
    transition: all 0.3s linear;

    &.dark {
      background-color: ${({ color, theme }) =>
        color ? color : theme.palette.background.default};
      color: #fff;
    }

    &.transparent {
      background-color: ${({ color }) =>
        color ? rgba(color, 0.1) : "transparent"};
      color: ${({ color, theme }) => color || theme.palette.text.primary};
    }
  }

  .right-menu {
    display: flex;
  }

  @media only screen and (max-width: 1580px) and (min-width: 991px) {
    .right-menu {
      display: none;
    }
  }
`;

export const StyledMiniInfoText = styled(Row)<{
  rightMenu?: boolean;
}>`
  display: flex;
  gap: 1px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.3s linear;
  margin-right: auto;
  max-width: calc(100% - ${({ rightMenu }) => (rightMenu ? "80px" : "0px")});
  width: 100%;

  @media only screen and (min-width: 1580px) {
    max-width: calc(100% - ${({ rightMenu }) => (rightMenu ? "165px" : "0px")});
  }
`;

export const StyledMiniInfoTitle = styled(Typography.Title)`
  font-size: 18px !important;
  font-weight: 500 !important;
  color: ${({ theme }) => theme["gray-color"]};
  margin: 0 !important;
  padding: 0 !important;
  transition: all 0.3s linear;
  width: 100%;
`;

export const StyledMiniInfoDesc = styled(Typography.Text)`
  font-size: 14px !important;
  font-weight: 400 !important;
  color: ${({ theme }) => theme["gray-color"]};
  margin: 0 !important;
  padding: 0 !important;
  transition: all 0.3s linear;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  width: 100%;
`;

export const StyledGrowContainer = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  position: relative;
`;

export const StyledDuration = styled.span`
  color: ${({ theme }) => theme.palette.text.hint};
  font-size: 12px;
  white-space: nowrap;
`;

export const StyledFlexSuccessContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.success.main};
  justify-content: flex-end;
`;

export const StyledDurationWrapper = styled.div`
  margin-top: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};

  span {
    font-size: ${({ theme }) => theme.font.size.sm};
  }
`;

export const StyledStatsBadge = styled.span<{ color: string }>`
  border-radius: 30px;
  background-color: ${({ color, theme }) =>
    color ? rgba(color, 0.095) : theme.palette.background.default};
  color: ${({ color, theme }) => color || theme.palette.text.primary};
  padding: 4px 12px;
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  display: inline-block;
  min-width: 80px;
  text-align: center;

  &.dark {
    background-color: ${({ color, theme }) =>
      color ? color : theme.palette.background.default};
    color: #fff;
  }

  &.transparent {
    background-color: ${({ color }) =>
      color ? rgba(color, 0.1) : "transparent"};
    color: ${({ color, theme }) => color || theme.palette.text.primary};
  }
`;
